import { Avatar, AvatarFallback } from "@/shared/components/ui/avatar";
import { cn } from "@/shared/lib/utils";
import type { RecordOwner } from "../types";

type RecordOwnerProps = {
  owner: RecordOwner;
  className?: string;
  compact?: boolean;
};

export function RecordOwnerDisplay({
  owner,
  className,
  compact = false,
}: RecordOwnerProps) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <Avatar className={compact ? "size-8" : "size-9"}>
        <AvatarFallback className="bg-primary/10 text-xs font-semibold text-primary">
          {owner.initials}
        </AvatarFallback>
      </Avatar>
      <span className="min-w-0 truncate text-sm font-medium text-foreground">
        {owner.name}
      </span>
    </div>
  );
}
